// import React from 'react';
// import fourdays from "../img/virtualroboticsbanners/whats-app-imge-removebg-preview (1).png"; // Importing the WhatsApp image

// const WhatsAppChat = () => {
//   const phoneNumber = " 8096120173"; // Replace with your WhatsApp number
//   const message = "Hello! How can we help you today?"; // Optional predefined message

//   // Handle click event to open WhatsApp chat
//   const handleClick = () => {
//     window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
//   };

//   return (
//     <div className="whatsapp-chat">
//       <img
//         src={fourdays} // Using the provided WhatsApp image
//         alt="WhatsApp"
//         width="60"
//         height="60"
//         className="whatsapp-button"
//         onClick={handleClick} // Trigger WhatsApp chat when the image is clicked
//       />
      
//       <style jsx>{`
//         .whatsapp-chat {
//           position: fixed;
//           bottom: 20px;
//           right: 20px;
//           z-index: 1000;
//         }

//         .whatsapp-button {
//           border-radius: 50%;
//           box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
//           cursor: pointer;
//           transition: transform 0.2s ease-in-out;
//         }

//         .whatsapp-button:hover {
//           transform: scale(1.1); /* Slightly increase the size on hover */
//         }
//       `}</style>
//     </div>
//   );
// };

// export default WhatsAppChat;


// import React from 'react';
// import fourdays from "../img/virtualroboticsbanners/whats-app-imge-removebg-preview (1).png"; // Importing the WhatsApp image

// const WhatsAppChat = () => {
//   const phoneNumber = "918096120173"; // Replace with your WhatsApp number, ensure to include +91 for India
//   const message = "Hello! How can we help you today?"; // Optional predefined message

//   // Handle click event to open WhatsApp chat
//   const handleClick = () => {
//     window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
//   };

//   return (
//     <div className="whatsapp-chat">
//       <img
//         src={fourdays} // Using the provided WhatsApp image
//         alt="WhatsApp"
//         width="60"
//         height="60"
//         className="whatsapp-button"
//         onClick={handleClick} // Trigger WhatsApp chat when the image is clicked
//       />
      
//       <style jsx>{`
//         .whatsapp-chat {
//           position: fixed;
//           bottom: 20px;
//           right: 20px;
//           z-index: 1000;
//         }

//         .whatsapp-button {
//           border-radius: 50%;
//           box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
//           cursor: pointer;
//           transition: transform 0.2s ease-in-out;
//         }

//         .whatsapp-button:hover {
//           transform: scale(1.1); /* Slightly increase the size on hover */
//         }
//       `}</style>
//     </div>
//   );
// };

// export default WhatsAppChat;



// import React from 'react';
// import fourdays from "../img/virtualroboticsbanners/whats-app-imge-removebg-preview (1).png"; // WhatsApp icon image

// const WhatsAppChat = () => {
//   const phoneNumber = "918096120173"; // Use full international format without +
//   const message = "Hi "; // Custom live chat-like message

//   const handleClick = () => {
//     // Open WhatsApp with pre-filled message
//     window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
//   };

//   return (
//     <div className="whatsapp-chat">
//       <img
//         src={fourdays}
//         alt="WhatsApp"
//         width="60"
//         height="60"
//         className="whatsapp-button"
//         onClick={handleClick}
//       />

//       <style jsx>{`
//         .whatsapp-chat {
//           position: fixed;
//           bottom: 20px;
//           right: 20px;
//           z-index: 1000;
//         }

//         .whatsapp-button {
//           border-radius: 50%;
//           box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
//           cursor: pointer;
//           transition: transform 0.2s ease-in-out;
//         }

//         .whatsapp-button:hover {
//           transform: scale(1.1);
//         }

//         @media (max-width: 768px) {
//           .whatsapp-chat {
//             bottom: 15px;
//             right: 15px;
//           }

//           .whatsapp-button {
//             width: 50px;
//             height: 50px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default WhatsAppChat;



import React from 'react';
import fourdays from "../img/virtualroboticsbanners/whats-app-imge-removebg-preview (1).png";

const WhatsAppChat = () => {
  const phoneNumber = "918096120173";
  const message = "Hi there! I need to know More about with your services.";

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="whatsapp-chat" onClick={handleClick}>
      <div className="tooltip">Live Chat</div>
      <img
        src={fourdays}
        alt="WhatsApp"
        width="60"
        height="60"
        className="whatsapp-button"
      />

      <style jsx>{`
        .whatsapp-chat {
          position: fixed;
          bottom: 17px;
          right: 79px;
          z-index: 1000;
          cursor: pointer;
        }

        .whatsapp-button {
          border-radius: 50%;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
          transition: transform 0.2s ease-in-out;
        }

        .whatsapp-button:hover {
          transform: scale(1.1);
        }

        .tooltip {
          position: absolute;
          bottom: 47px;
          right: 79;
          background-color: #25D366;
          color: white;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 14px;
          white-space: nowrap;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .whatsapp-chat:hover .tooltip {
          opacity: 1;
          transform: translateY(0);
        }

        @media (max-width: 768px) {
          .whatsapp-chat {
            bottom: 15px;
            right: 15px;
          }

          .whatsapp-button {
            width: 50px;
            height: 50px;
          }

          .tooltip {
            font-size: 12px;
            padding: 4px 10px;
            bottom: 17px;
          }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppChat;



